export default "__VITE_ASSET__CDEbJCI8__"